import { computed, ref } from 'vue'
import type { ComputedRef } from 'vue'

const openKeys = ref<string[]>([])

const isEmpty = computed((): boolean => openKeys.value.length === 0)

export function useDialogStack(): {
    open: (key: string) => void
    close: (key: string) => void
    isEmpty: ComputedRef<boolean>
} {
    function open(key: string): void {
        const withoutKey = openKeys.value.filter((existing) => existing !== key)
        openKeys.value = [...withoutKey, key]
    }

    function close(key: string): void {
        openKeys.value = openKeys.value.filter((existing) => existing !== key)
    }

    return {
        open,
        close,
        isEmpty,
    }
}
